var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgLockedpl(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    className: "icon othersSVGs",
    width: 19,
    height: 19,
    viewBox: "0 0 19 19",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1_76)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M9.48102 0.643555C11.8042 0.643817 13.692 2.55293 13.692 4.89746C13.6917 5.1427 13.4948 5.34277 13.2496 5.34277C13.0043 5.34277 12.8074 5.14271 12.8072 4.89746C12.8072 3.04319 11.314 1.53542 9.48102 1.53516C7.6479 1.53516 6.15387 3.04303 6.15387 4.89746V8.25879H13.9351C14.9357 8.25894 15.7474 9.08056 15.7476 10.0889V16.3203C15.7475 17.3287 14.9358 18.1502 13.9351 18.1504H5.02594C4.02531 18.1502 3.21356 17.3287 3.21344 16.3203V10.0889C3.21368 9.08056 4.02538 8.25895 5.02594 8.25879H5.2691V4.89746C5.2691 2.55277 7.15766 0.643555 9.48102 0.643555ZM5.02594 9.15039C4.51562 9.15056 4.09845 9.57083 4.09821 10.0889V16.3203C4.09833 16.8385 4.51555 17.2586 5.02594 17.2588H13.9351C14.4455 17.2586 14.8627 16.8385 14.8629 16.3203V10.0889C14.8626 9.57083 14.4454 9.15055 13.9351 9.15039H5.02594Z",
    fill: "currentColor",
    stroke: "currentColor",
    strokeWidth: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.48053 10.4354C8.53587 10.4354 7.76733 11.2119 7.76733 12.1662C7.76733 13.002 8.35684 13.7014 9.13789 13.8622V15.6277C9.13789 15.8189 9.29129 15.9739 9.48053 15.9739C9.66973 15.9739 9.82316 15.8189 9.82316 15.6277V13.8622C10.6042 13.7013 11.1937 13.002 11.1937 12.1662C11.1937 11.2119 10.4252 10.4354 9.48053 10.4354ZM9.48053 13.2047C8.91373 13.2047 8.45261 12.7388 8.45261 12.1662C8.45261 11.5936 8.91373 11.1277 9.48053 11.1277C10.0473 11.1277 10.5084 11.5936 10.5084 12.1662C10.5084 12.7388 10.0473 13.2047 9.48053 13.2047Z",
    fill: "currentColor"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 12.8418,
    y: 4.86816,
    width: 1.08203,
    height: 3.49817,
    fill: "currentColor"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1_76"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 17.8172,
    height: 18,
    fill: "white",
    transform: "translate(0.572266 0.398438)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLockedpl);
export default __webpack_public_path__ + "static/media/Lockedpl.838fb4e996d83c65b7b876f598dd2eb2.svg";
export { ForwardRef as ReactComponent };